import { Link } from "react-router-dom";
import { btn, btnGhost } from "../../lib/ui.ts";

type ButtonProps = {
  ghost?: boolean;
  className?: string;
  children: React.ReactNode;
} & (
  | {
      to: string;
      href?: never;
      rel?: never;
      target?: never;
      disabled?: never;
      type?: never;
      onClick?: never;
    }
  | {
      href: string;
      to?: never;
      rel?: string;
      target?: string;
      disabled?: never;
      type?: never;
      onClick?: never;
    }
  | {
      to?: never;
      href?: never;
      rel?: never;
      target?: never;
      disabled?: boolean;
      type?: "button" | "submit";
      onClick?: () => void;
    }
);

export function Button(props: ButtonProps) {
  const classes = props.ghost ? btnGhost : btn;
  const combined = props.className ? `${classes} ${props.className}` : classes;

  if ("to" in props && props.to) {
    return (
      <Link className={combined} to={props.to}>
        {props.children}
      </Link>
    );
  }
  if ("href" in props && props.href) {
    return (
      <a className={combined} href={props.href} rel={props.rel} target={props.target}>
        {props.children}
      </a>
    );
  }
  return (
    <button
      className={combined}
      type={props.type ?? "button"}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}
